import client from './client';

/**
 * LinkPage Service
 * Handles public API calls for the linkPage feature
 * 
 * Backend Endpoint:
 * - Public: GET /api/v1/public/businesses/:slug/page
 */

/**
 * Fetches public link page data for a business by slug
 * 
 * Expected backend response format:
 * {
 *   business: {
 *     _id: string,
 *     name: string,
 *     urlSlug: string,
 *     logo: string,
 *     color: string,
 *     socialMediaLinks: object,
 *     linkPage: {
 *       enabled: boolean,
 *       title: string,
 *       bio: string,
 *       socialEnabled: boolean
 *     }
 *   },
 *   links: [  // Links array at root level, not nested in business
 *     {
 *       _id: string,
 *       title: string,
 *       buttonText: string,
 *       url: string,
 *       enabled: boolean,
 *       position: number,
 *       icon: { type: string, value: string }
 *     }
 *   ]
 * }
 * 
 * @param {string} slug - The business URL slug
 * @returns {Promise<Object>} The link page payload from backend
 */
export const getPublicLinkPageBySlug = async (slug) => {
  try {
    // Client baseURL already includes /api/v1/public
    const response = await client.get(`/businesses/${slug}/page`);
    return response.data;
  } catch (error) {
    // If 404, the linkPage might not be enabled or doesn't exist
    if (error.response?.status === 404) {
      throw new Error('Link page not found or not enabled');
    }
    throw error;
  }
};
